import React, { useEffect, useState } from 'react';
import HomePage from './components/HomePage';
import UploadPage from './components/UploadPage';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [uploadToken, setUploadToken] = useState(null);

  useEffect(() => {
    // Check URL for upload token (magic link)
    let token = null;

    // Method 1: Extract from path-based URL (/u/{token})
    const pathMatch = window.location.pathname.match(/^\/u\/([a-zA-Z0-9_-]+)$/);
    if (pathMatch) {
      token = pathMatch[1];
    }

    // Method 2 (fallback): Extract from query parameter (?token={token})
    // Provides backward compatibility for any existing links
    if (!token) {
      const urlParams = new URLSearchParams(window.location.search);
      token = urlParams.get('token');
    }

    if (token) {
      // Validate token format (URL-safe base64, 32+ characters)
      // secrets.token_urlsafe(32) generates 43-character tokens
      if (token.length >= 32 && /^[a-zA-Z0-9_-]+$/.test(token)) {
        setCurrentPage('upload');
        setUploadToken(token);

        // Clean up URL to remove token from address bar for security
        const cleanUrl = window.location.protocol + "//" + window.location.host + "/u";
        window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
      } else {
        console.error('Invalid token format detected:', token);
      }
    }
  }, []);

  // Enable PWA install prompt
  useEffect(() => {
    let deferredPrompt;
    
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      
      // Show install banner after a short delay
      setTimeout(() => {
        if (deferredPrompt && window.innerWidth <= 768) {
          const banner = document.createElement('div');
          banner.className = 'fixed bottom-4 left-4 right-4 bg-blue-600 text-white p-3 rounded-lg shadow-lg z-50';
          banner.innerHTML = `
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <p class="font-medium text-sm">Install DoqChase App</p>
                <p class="text-xs opacity-90">Quick access from your home screen</p>
              </div>
              <button id="install-btn" class="bg-white text-blue-600 px-3 py-1 rounded text-sm font-medium ml-3">Install</button>
              <button id="dismiss-btn" class="text-white ml-2">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          `;
          
          document.body.appendChild(banner);
          
          banner.querySelector('#install-btn').addEventListener('click', async () => {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            console.log(`User response to install prompt: ${outcome}`);
            deferredPrompt = null;
            banner.remove();
          });
          
          banner.querySelector('#dismiss-btn').addEventListener('click', () => {
            banner.remove();
          });
        }
      }, 3000);
    };
    
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  return (
    <div className="App">
      {currentPage === 'upload' ? (
        <UploadPage token={uploadToken} />
      ) : (
        <HomePage />
      )}
    </div>
  );
}

export default App;